import 'vue-cookie-accept-decline/dist/vue-cookie-accept-decline.css'
import Vue from 'vue'
import VueCookieAcceptDecline from 'vue-cookie-accept-decline'

Vue.component('vue-cookie-accept-decline', VueCookieAcceptDecline)
